import { Injectable } from "@angular/core";
import { Device } from "@capacitor/device";
import { ActionPerformed, PushNotifications, PushNotificationSchema, Token } from "@capacitor/push-notifications";
import { NavController, ToastController } from '@ionic/angular';
import { TranslateService } from "@ngx-translate/core";
import { firstValueFrom } from "rxjs";
import { OrderModel } from "src/app/models/order.model";
import { UserModel } from "src/app/models/user.model";
import { DataService } from "../data/data.service";
import { OrderService } from "../order/order.service";

@Injectable({
  providedIn: "root"
})


export class NotificationService {

  notificationToken: string;


  constructor(public nav: NavController, public dataService: DataService,
    private translateService:TranslateService, private toastCtrl:ToastController,
    private orderService:OrderService) {}

  async checkNotificationToken(user:UserModel){
    const info = await Device.getInfo();
    const uuid = (await Device.getId()).identifier;
    // console.log('checkNotificationToken',info,uuid);
    if(this.notificationToken == 'web' || info.platform == "web"){
      // console.log('web');
      return new Promise((resolve, reject) => { resolve('web')});
    } 
    else{
      user.devices = await firstValueFrom(this.dataService.getUserDevices(user.uid));
      if(user.devices && user.devices[uuid]){
        // let date = new Date(user.devices[uuid].dateTime);
        // const now = new Date();
        // date.setDate(date.getDate()+14);
        // if(date < now){
        //   console.log('notification token expired', user.devices[uuid]);
        // }
        await this.getAndSaveNotificationToken(user,uuid, info);
      }
      else{
        // Request permission to use push notifications
        // iOS will prompt user and return if they granted permission or not
        // Android will just grant without prompting
        // Register with Apple / Google to receive push via APNS/FCM
        // On success, we should be able to receive notifications
        // console.log('notification request permission');
        const result = await PushNotifications.requestPermissions();
        // console.log('notification request permission result',result);
        if (result.receive === 'granted') {
          await this.getAndSaveNotificationToken(user, uuid, info);
        }      
      }
    }
    Promise.resolve();
  }

  async getAndSaveNotificationToken(user: UserModel, uuid:string, device: any):Promise<string> {
    PushNotifications.addListener("registration", (token: Token) => {
      // console.log('notification registered',uuid, user.devices, token);
      if(!user.devices || user.devices[uuid].token !== token){
        // console.log('notification new token',user.devices, token);
        this.dataService.setUserToken(user, token.value, uuid, device);
      }
    });

    // Some issue with our setup and push will not work
    PushNotifications.addListener("registrationError", (error: any) => {
      // console.log("notification error on registration: " + JSON.stringify(error));
    });

    // Show us the notification payload if the app is open on our device
    PushNotifications.addListener("pushNotificationReceived", (notification: PushNotificationSchema) => {
      // console.log("Push received: ", notification);
      if(notification.data.type == 'order'){
        this.reactToOrder(notification.body,notification.title, notification.data.url, notification.data.orderKey, notification.data.tourneeKey,notification.data.producerKey);
      }
      else{
        this.presentToast(notification.body,notification.title, notification.data.url);
      }
    });

    // Method called when tapping on a notification
    PushNotifications.addListener("pushNotificationActionPerformed", (notification: ActionPerformed) => {
      // console.log('notification clicked',JSON.stringify(notification), notification.notification.data.url);
      this.nav.navigateRoot(notification.notification.data.url).catch(error => console.log(error));
    });
    const registerResult = await PushNotifications.register();
    // console.log('register notification result',registerResult);
    return new Promise((resolve, reject) => { resolve('registered')});
  }

  async reactToOrder(header,message,url, orderKey, tourneeKey,producerKey) {
    const order:OrderModel = {
      key: orderKey,
      tournee:{
        key:tourneeKey,
        producer:{
          key:producerKey
        }
      },
      producer:{
        key:producerKey
      }
    }
    const toast = await this.toastCtrl.create({
      header:header,
      message: message,
      duration:15000,
      cssClass:'toast',
      buttons:[{
        cssClass:'toast-button',
        side:'end',
          // text:this.translateService.instant('buttons.View'),
          icon:'arrow-redo-outline',
          handler:async ()=>{
            // console.log('view clicked',url);
            this.nav.navigateRoot(url);
          }
        },
        {
          cssClass:'toast-button',
          side:'end',
          icon:'thumbs-up-outline',
          handler:async ()=>{
            // console.log('accept clicked');
            this.orderService.markOrderAccepted(order,order.tournee).then(_ => {
              toast.dismiss();
                this.presentToast(this.translateService.instant('order.OrderAccepted'),message,url)
              }
            )
          }
        }
      ],
      position: 'top'
    });
    toast.present();
  }

  async presentToast(header,message,url) {
    const toast = await this.toastCtrl.create({
      header:header,
      message: message,
      duration:15000,
      cssClass:'toast',
      buttons:[{
          side:'end',
          icon:'arrow-redo-outline',
          cssClass:'toast-button',
          handler:()=>{
            // console.log(url);
            this.nav.navigateRoot(url);
          }
      }],
      position: 'top'
    });
    toast.present();
  }

  closeToast(){
    if(typeof(this.toastCtrl) != 'undefined'){
          this.toastCtrl.dismiss();
    } 
  }
}
